import { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { AiOutlineDownload } from "react-icons/ai";
import Particle from "../Particle";
import { useLang } from "../../context/LanguageContext";
import { translations } from "../../translations";
//import presentationVideo from "../../Assets/video_presentazione.mp4";
import cv from "../../Assets/CV_Mileva_v5.pdf";

const VIDEO_PASSWORD = "GoleeVideo01";

function Presentation() {
  const { lang } = useLang();
  const tr = translations[lang].presentation;
  const [password, setPassword] = useState("");
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (password === VIDEO_PASSWORD) {
      setError(false);
      setUnlocked(true);
    } else {
      setError(true);
    }
  }

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={8}
            style={{
              paddingTop: "30px",
              paddingBottom: "50px",
              position: "relative",
              zIndex: 2,
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              {tr.title} <strong className="purple">{tr.titleHighlight}</strong>
            </h1>

            {!unlocked ? (
              <>
                <p>{tr.subtitle}</p>
                <Form onSubmit={handleSubmit} className="d-flex" style={{ gap: "10px", flexWrap: "wrap" }}>
                  <Form.Control
                    type="password"
                    placeholder={tr.placeholder}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ maxWidth: "300px" }}
                  />
                  <Button type="submit" className="btn-primary">
                    {tr.submit}
                  </Button>
                </Form>
                {error && (
                  <p style={{ color: "#dc3545", marginTop: "10px" }}>
                    {tr.wrongPassword}
                  </p>
                )}
              </>
            ) : (
              <>
                {/* <video
                  src={presentationVideo}
                  controls
                  autoPlay
                  className="img-fluid"
                  style={{ width: "100%", borderRadius: "5px" }}
                /> */}
                <div style={{ marginTop: "20px" }}>
                  <Button
                    variant="primary"
                    href={cv}
                    download="CV_Mileva.pdf"
                    style={{ maxWidth: "250px" }}
                  >
                    <AiOutlineDownload />
                    &nbsp;{translations[lang].resume.download}
                  </Button>
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Presentation;
